import Vue from 'vue'
import {mapActions} from 'vuex'
import _ from 'lodash'
import DateUtil from '@/utils/date'

const Bus = new Vue()
window.Vue = Vue

Vue.mixin({
  methods: {
    eventBusEmit (event, ...args) {
      Bus.$emit(event, ...args)
    },
    eventBusOn (event, callback) {
      Bus.$on(event, callback)
    },
    eventBusOff (event, callback) {
      Bus.$off(event, callback)
    },
  },
})

export const dialogCommon = {
  methods: {
    ...mapActions('home', ['changeGlobalDialog', 'changeGlobalUpDialog']),
    dialogHide (val) {
      this.changeGlobalDialog({
        visible: false,
        // component: '',
        confirmed: val,
      })
      let _this = this
      this.$nextTick(() => {
        _this.changeGlobalDialog({
          component: '',
        })
      })
    },
    upDialogHide (val) {
      this.changeGlobalUpDialog({
        visible: false,
        component: '',
        confirmed: val,
      })
    },
  },
}

let scrollBody, headerDom, fixedTop, scrollCB, btnScroll

function _scrollCB () {
  return _.throttle(() => {
    if (scrollBody.scrollTop >= fixedTop) {
      headerDom.classList.add('fixed-bottom')
      btnScroll.classList.add('btn-box-fixed')
    } else {
      headerDom.classList.remove('fixed-bottom')
      btnScroll.classList.remove('btn-box-fixed')
    }
  }, 100)
}

export const btnScrollFixed = {
  activated () {
    scrollBody = document.querySelector('.el-main')
    headerDom = document.querySelector('.el-header')
    btnScroll = document.querySelector('#btnScroll')
    fixedTop = btnScroll.offsetTop - 50
    scrollCB = _scrollCB()
    scrollCB()
    scrollBody.addEventListener('scroll', scrollCB)
    this.$once('hook:deactivated', () => {
      headerDom.classList.remove('fixed-bottom')
      btnScroll.classList.remove('btn-box-fixed')
      scrollBody.removeEventListener('scroll', scrollCB)
      scrollBody = null
      headerDom = null
      fixedTop = null
      scrollCB = null
    })
  },
}

export const timerange = {
  data () {
    let that = this
    return {
      startLimit: {
        disabledDate (time) {
          if (!that.query.endTime) return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          return time.getTime() > new Date(that.query.endTime).getTime()
        },
      },
      endLimit: {
        disabledDate (time) {
          if (!that.query.startTime) return time.getTime() < (new Date(new Date().toLocaleDateString()).getTime() - 1)
          return time.getTime() < new Date(that.query.startTime).getTime()
        },
      },
    }
  },
}
export const daterange = {
  data () {
    let that = this
    return {
      startLimit: {
        disabledDate (time) {
          if (that.params.endTime) {
            return time.getTime() > new DateUtil(that.params.endTime).getTime()
          }
        },
      },
      endLimit: {
        disabledDate (time) {
          if (that.params.startTime) {
            return time.getTime() < new DateUtil(that.params.startTime).getTime()
          }
        },
      },
    }
  },
}
function _dealRowProperty (selectTask) {
  // 每个页面表格列表中需要取到的唯一字段，用来判断当前具体是那个页面，需要把唯一字段保存到 arr 变量中
  // 特别注意该字段在表格里每行数据中值必须唯一
  // taskId --- 作业管理模块页面表格列表字段
  // userId --- 用户管理模块用户列表页面表格列表字段
  // id --- 节点机管理模块节点机列表页面表格列表字段
  // pluginName --- 配置管理模块插件配置页面表格列表字段
  // activityName --- 配置管理模块渲染卷页面表格列表字段
  // loginName --- 管理员管理模块代理列表页面表格列表字段
  const arr = ['id', 'taskId', 'nodeId', 'userId', 'pluginName', 'activityName', 'loginName']
  let obj = selectTask[0] ? selectTask[0] : {}
  let intersection = _.intersection(arr, Object.keys(obj))
  return intersection[0] ? intersection[0] : 'error'
}

export const hightLightRow = {
  methods: {
    highLight ({row}) {
      let identity = _dealRowProperty(this.selectTask)
      if (this.selectTask.map(v => v[identity]).includes(row[identity])) {
        return 'highLight'
      } else {
        return ''
      }
    },
  },
}

export const splitString = {
  methods: {
    splitString (value, separator = ',') {
      if (!!value && typeof value === 'string') {
        const dataArray = value.split(separator)
        return dataArray.map((data, index) => (index !== dataArray.length - 1 ? `${data}${separator}` : data))
      }
      return ['']
    },
  },
}

export * from './hardware-config'
